import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/Button';
import { useTheme } from '../contexts/ThemeContext';
interface WelcomeScreenProps {
  onGetStarted: () => void;
  onExplore: () => void;
}
export function WelcomeScreen({
  onGetStarted,
  onExplore
}: WelcomeScreenProps) {
  const {
    isLight
  } = useTheme();
  return <div className="h-full flex flex-col items-center justify-between p-6 relative overflow-hidden" data-id="element-3758" data-mp="2d8jcidlr0o9i">
      {/* Decorative gradient orbs for glass depth */}
      <div className={`absolute top-20 -left-20 w-60 h-60 rounded-full blur-3xl pointer-events-none ${isLight ? 'bg-vexu/20' : 'bg-vexu/10'}`} data-id="element-3759" data-mp="2n0fdpxj4suhy" />
      <div className={`absolute bottom-40 -right-20 w-60 h-60 rounded-full blur-3xl pointer-events-none ${isLight ? 'bg-vexu/10' : 'bg-vexu/5'}`} data-id="element-3760" data-mp="30x2nx203hh5t" />

      <div className="flex-1 flex flex-col items-center justify-center text-center space-y-8 w-full relative z-10" data-id="element-3761" data-mp="16lxok9w1jqwa">
        <div className="relative" data-id="element-3762" data-mp="11o5ogsl8syh0">
          <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 1,
          ease: 'easeOut'
        }} className={`absolute inset-0 blur-3xl rounded-full animate-pulse ${isLight ? 'bg-vexu opacity-30' : 'bg-vexu opacity-20'}`} data-id="element-3763" data-mp="1yucq9apovbpj" />
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          type: 'spring'
        }} className={`relative w-32 h-32 rounded-[32px] overflow-hidden transition-colors duration-500 shadow-2xl shadow-vexu/10`} data-id="element-3764" data-mp="2hk2h5mqbzdc6">
            <img src="https://cdn.magicpatterns.com/uploads/3A8d459aXLumR8KKFCQtrD/vexu_logo.svg" alt="Vexu Logo" className="w-full h-full object-cover scale-[1.15]" data-id="element-3765" data-mp="115sx34t4gar5" />
          </motion.div>
        </div>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="space-y-3 max-w-xs" data-id="element-3766" data-mp="1zk9lse7dw6bx">
          <h1 className={`text-4xl font-bold tracking-tight transition-colors duration-500 ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-3767" data-mp="2ih0yu5wc1p7j">
            Vexu.ai
          </h1>
          <p className={`text-lg font-medium transition-colors duration-500 ${isLight ? 'text-vexu-600' : 'text-vexu'}`} data-id="element-3768" data-mp="2x7qfvowh5yjb">
            Your AI personal assistant
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 0.6
    }} className="w-full space-y-4 mb-8 relative z-10" data-id="element-3769" data-mp="318a8qga0mfzn">
        <Button fullWidth size="lg" onClick={onGetStarted} className={isLight ? 'shadow-lg shadow-vexu/20' : 'shadow-lg shadow-vexu/20'} data-id="element-3770" data-mp="3btdxp3f7gqz0">
          Get Started
        </Button>
        <button onClick={onExplore} className={`w-full text-center text-sm font-medium transition-colors ${isLight ? 'text-slate-500 hover:text-slate-900' : 'text-zinc-500 hover:text-white'}`} data-id="element-3771" data-mp="320q1oaw1ur1c">
          Explore App
        </button>
      </motion.div>
    </div>;
}